.mappedin__smart-collision-engine__container {
	position: absolute;
	left: 0px;
	top: 0px;
	bottom: 0px;
	right: 0px;
	pointer-events: none;
	/* Enables colliders to use translate3D */
	transform-style: preserve-3d;
	font-family: 'InterUI-Regular', Helvetica, Arial, sans-serif;
}

.mappedin__smart-collision-engine-debug__container {
	position: absolute;
	left: 0px;
	top: 0px;
	bottom: 0px;
	right: 0px;
	transition: opacity 300ms ease-in-out;
	pointer-events: none;
	will-change: opacity;
	&.interacting {
		opacity: 0.2;
	}
}
